import { getLastPaymentStatus as getLastPaymentStatusApi } from '../api/order';

export const UPDATE_PAYMENT_HISTORY = 'updatePaymentHistory';
export const SET_HAS_POLLING_BEEN_REINSTATED = 'setHasPollingBeenReinstated';

/**
 * Updates the payment history with its new value
 * @param {Object} data: the new payment history
 */
export const updatePaymentHistory = (data) => ({
    type: UPDATE_PAYMENT_HISTORY,
    payload: data,
});

/**
 * Sets whether polling has been reinstated
 * @param {boolean} hasPollingBeenReinstated: whether polling has been reinstated
 */
export const setHasPollingBeenReinstated = (hasPollingBeenReinstated) => ({
    type: SET_HAS_POLLING_BEEN_REINSTATED,
    payload: hasPollingBeenReinstated,
});

/**
 * Fetches the last payment status for a given order
 * @param {String} orderId the order ID to fetch the payment history for
 */
export const getLastPaymentStatus = (orderId) => async (dispatch) => {
    const paymentResponse = await dispatch(getLastPaymentStatusApi(orderId));

    dispatch(updatePaymentHistory(paymentResponse.response));
};
